import { ERROR_CODE } from './code';

type HybridErrorParams = {
  code: ERROR_CODE;
  api: string;
  message: string;
  details?: Record<string, unknown>;
};

class HybridError extends Error {
  readonly code: number;
  readonly api: string;
  readonly details?: Record<string, unknown>;

  constructor({ code, api, message, details }: HybridErrorParams) {
    super(message);
    this.code = code;
    this.api = api;
    this.details = details;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  toJSON() {
    return {
      code: this.code,
      api: this.api,
      message: this.message,
      details: this.details,
    };
  }
}

const createError = (params: HybridErrorParams) => new HybridError(params);

export type { HybridErrorParams };
export { createError };
